import {
  Card,
  CardBody,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  Table,
  CardHeader,
  CardTitle,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
  Button,
} from "reactstrap";
import { useState, React, useEffect, useContext } from "react";
import { NavLink, useHistory } from "react-router-dom";
import Moment from "moment";
import "moment-timezone";
import { ToastContainer, toast } from "react-toastify";
import LoadingOverlay from "react-loading-overlay";
LoadingOverlay.propTypes = undefined;
import { MainContext } from "context/MainContext.js";
import ReactBSAlert from "react-bootstrap-sweetalert";

import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Utilities from "components/Utils/utilities";

const VersionsList = () => {
  const history = useHistory();
  const privileges = useContext(MainContext);

  useEffect(() => {
    if (!Utilities.hasAccess(privileges["versions.list.display"])) {
      history.push({
        pathname: "/",
      });
    } else if (Utilities.hasAgreedTerms() == "false") {
      history.push({
        pathname: "/auth/terms",
      });
    }
  }, []);

  const [errorMsg, setErrorMsg] = useState([]);
  const [showLoading, setShowLoading] = useState(false);

  const [data, setData] = useState([]);
  const [settings, setSettings] = useState([]);
  const [alert, setAlert] = useState(null);

  const [currentVersion, setCurrentVersion] = useState(
    sessionStorage.getItem("currentVersion"),
  );

  useEffect(() => {
    fetchData("manual");

    const intervalIDValue = setInterval(() => {
      fetchData("auto");
    }, 15000);

    return () => {
      clearInterval(intervalIDValue);
    };
  }, []);

  const [sortOrder, setSortOrder] = useState({
    column: "version",
    order: "desc",
  });

  const fetchData = (mode) => {
    if (mode == "manual") {
      setShowLoading(true);
    }
    const start = Date.now();
    fetch("/api/v1/version/list", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
        mode: mode,
      },
    })
      .then((response) => response.json())
      .then((actualData) => {
        if (actualData.status == "200") {
          setData(actualData.data);
          setSettings(actualData.settings);
        }

        if (mode == "manual") {
          setShowLoading(false);
        }
      })
      .catch((err) => {
        console.log(err.message);
        if (mode == "manual") {
          setShowLoading(false);
        }
      });
  };

  const hideAlert = () => {
    setAlert(null);
  };

  const deleteConfirm = (filename) => {
    setAlert(
      <ReactBSAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title="Are you sure you want to delete this version ?"
        onConfirm={() => {
          deleteVersion(filename);
        }}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="info"
        confirmBtnText="Yes"
        cancelBtnText="Cancel"
        showCancel
        btnSize=""
      >
        You will not be able to revert this action
      </ReactBSAlert>,
    );
  };

  const deleteVersion = (filename) => {
    setShowLoading(true);
    fetch("/api/v1/version/delete", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
      body: JSON.stringify({
        filename: filename,
      }),
    })
      .then((response) => response.json())
      .then((actualData) => {
        hideAlert();
        setShowLoading(false);
        if (actualData.error_code) {
          toast.error("A problem occured while removing the version", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
        } else {
          fetchData("auto");
          toast.success("Version removed successfully", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
        }
      })
      .catch((err) => {
        setShowLoading(false);
        console.log(err.message);
      });
  };

  const deployConfirm = (filename) => {
    setAlert(
      <ReactBSAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title="Are you sure you want to deploy this version ?"
        onConfirm={() => {
          deploy(filename);
        }}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="info"
        confirmBtnText="Yes"
        cancelBtnText="Cancel"
        showCancel
        btnSize=""
      ></ReactBSAlert>,
    );
  };

  const deploy = (filename) => {
    hideAlert();
    setShowLoading(true);
    fetch("/api/v1/version/deploy", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
      body: JSON.stringify({
        filename: filename,
      }),
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);
        if (actualData.error_code) {
          setErrorMsg(actualData.error_code);
          toast.error("A problem occured while deploying the version", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
        } else {
          setErrorMsg([]);
          const location = {
            pathname: "/admin/maintenance",
          };
          history.push(location);
        }
      })
      .catch((err) => {
        setShowLoading(false);
        console.log(err.message);
      });
  };

  const reboot = () => {
    setShowLoading(true);
    fetch("/api/v1/version/reboot", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);
        if (actualData.error_code) {
          toast.error("A problem occured while restarting Virtuoso", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
        } else {
          const location = {
            pathname: "/admin/maintenance",
          };
          history.push(location);
        }
      })
      .catch((err) => {
        setShowLoading(false);
        console.log(err.message);
      });
  };

  const changeSortOrder = (columnName) => {
    if (sortOrder.column == columnName) {
      setSortOrder({
        ...sortOrder,
        order: sortOrder.order == "asc" ? "desc" : "asc",
      });
    } else {
      setSortOrder({
        column: columnName,
        order: "asc",
      });
    }
  };

  return (
    <>
      <ToastContainer />
      <div className="content">
        <LoadingOverlay
          active={showLoading}
          spinner
          text="Loading"
          className={showLoading ? "loading" : ""}
        />
        {alert}
        <Row>
          <Col md="12">
            <Card>
              <CardBody>
                <Breadcrumb>
                  <BreadcrumbItem>
                    <NavLink
                      to={{
                        pathname: "/admin/dashboard",
                      }}
                    >
                      <FontAwesomeIcon icon={faHome} />
                    </NavLink>
                  </BreadcrumbItem>
                  <BreadcrumbItem>Virtuoso Versions List</BreadcrumbItem>
                </Breadcrumb>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">Virtuoso Versions List</CardTitle>
              </CardHeader>
              <CardBody>
                {Array.isArray(errorMsg) && errorMsg.length > 0 ? (
                  <div
                    style={{
                      backgroundColor: "#FFC0A4",
                      border: "1px solid #ef8157",
                      color: "#66615b",
                      paddingTop: "15px",
                      marginBottom: "15px",
                    }}
                  >
                    <ul>
                      {errorMsg.map((d, index) => (
                        <li key={index}>{d}</li>
                      ))}
                    </ul>
                  </div>
                ) : (
                  ""
                )}
                <Table striped>
                  <thead className="text-primary">
                    <tr>
                      <th onClick={() => changeSortOrder("version")}>
                        Version{" "}
                        {sortOrder.column === "version" &&
                        sortOrder.order === "asc"
                          ? "↑"
                          : ""}
                        {sortOrder.column === "version" &&
                        sortOrder.order === "desc"
                          ? "↓"
                          : ""}
                      </th>
                      <th onClick={() => changeSortOrder("size")}>
                        Size{" "}
                        {sortOrder.column === "size" &&
                        sortOrder.order === "asc"
                          ? "↑"
                          : ""}
                        {sortOrder.column === "size" &&
                        sortOrder.order === "desc"
                          ? "↓"
                          : ""}
                      </th>
                      <th onClick={() => changeSortOrder("uploadedDate")}>
                        Uploaded Date{" "}
                        {sortOrder.column === "uploadedDate" &&
                        sortOrder.order === "asc"
                          ? "↑"
                          : ""}
                        {sortOrder.column === "uploadedDate" &&
                        sortOrder.order === "desc"
                          ? "↓"
                          : ""}
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {data
                      .sort((a, b) => {
                        const aValue = a[sortOrder.column];
                        const bValue = b[sortOrder.column];

                        if (aValue == null && bValue == null) return 0;
                        if (aValue == null)
                          return sortOrder.order === "asc" ? -1 : 1;
                        if (bValue == null)
                          return sortOrder.order === "asc" ? 1 : -1;

                        if (sortOrder.order === "asc") {
                          return aValue
                            .toString()
                            .localeCompare(bValue.toString());
                        } else {
                          return bValue
                            .toString()
                            .localeCompare(aValue.toString());
                        }
                      })
                      .map((version, i) => {
                        return (
                          <tr
                            key={i}
                            className={
                              version.version == currentVersion
                                ? "trBaseline"
                                : ""
                            }
                          >
                            <td>{version.version}</td>
                            <td>{version.size}</td>
                            <td>
                              {settings != undefined
                                ? settings.general_convert_date_with_user_timezone ===
                                  "true"
                                  ? Moment(version.uploadedDate)
                                      .tz(settings.user_timezone)
                                      .format("yy-MM-DD hh:mm:ss a")
                                  : Moment.utc(version.uploadedDate).format(
                                      "yy-MM-DD hh:mm:ss a",
                                    )
                                : data.settings}
                            </td>
                            <td>
                              {version.version != currentVersion ? (
                                <UncontrolledDropdown direction="down">
                                  <DropdownToggle
                                    caret
                                    color="info"
                                    style={{
                                      lineHeight: "0.2em",
                                    }}
                                  >
                                    Actions
                                  </DropdownToggle>
                                  <DropdownMenu container={"body"}>
                                    {Utilities.hasAccess(
                                      privileges["versions.list.deploy"],
                                    ) ? (
                                      <DropdownItem
                                        onClick={() =>
                                          deployConfirm(version.filename)
                                        }
                                      >
                                        Deploy
                                      </DropdownItem>
                                    ) : (
                                      ""
                                    )}
                                    {Utilities.hasAccess(
                                      privileges["versions.list.delete"],
                                    ) ? (
                                      <DropdownItem
                                        onClick={() =>
                                          deleteConfirm(version.filename)
                                        }
                                      >
                                        Delete
                                      </DropdownItem>
                                    ) : (
                                      ""
                                    )}
                                  </DropdownMenu>
                                </UncontrolledDropdown>
                              ) : (
                                <>
                                  {Utilities.hasAccess(
                                    privileges["versions.list.deploy"],
                                  ) ? (
                                    <UncontrolledDropdown direction="down">
                                      <DropdownToggle
                                        caret
                                        color="info"
                                        style={{
                                          lineHeight: "0.2em",
                                        }}
                                      >
                                        Actions
                                      </DropdownToggle>
                                      <DropdownMenu container={"body"}>
                                        <DropdownItem onClick={() => reboot()}>
                                          Restart Virtuoso
                                        </DropdownItem>
                                      </DropdownMenu>
                                    </UncontrolledDropdown>
                                  ) : (
                                    ""
                                  )}
                                </>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default VersionsList;
